;; Generated by dev/generate_themes.clj — do not edit by hand.
;; Regenerate with: devbox run generate-themes
;;
;; A committed mirror of dsl/instances/themes.edn (ADR-graph-ui-v0-009-01):
;; the built-in theme set + the closed token vocabulary. graph-ui.web.theme
;; reads this to apply a theme as CSS custom properties in the browser, so
;; the running palette can never drift from the declared theme data.

(ns graph-ui.web.generated-themes)

(def theme-data
  {:token-means
 {:icon-xs "The smallest icon: inside a dense row.",
  :opacity-strong
  "Nearly solid — a wash that must still be read through.",
  :layer-instrument
  "Above everything: a ruler, an x-ray, a measuring overlay.",
  :stroke-emphasis "A line that must be noticed — a selected edge.",
  :radius-md "The corner of a button, an input, a card.",
  :control-border "The outline around a button or an input.",
  :motion-fast "How long a small change takes — a hover, a toggle.",
  :layer-sticky "A bar that stays while the rest scrolls.",
  :icon-sm "An icon beside a line of text.",
  :type-h2 "A section heading.",
  :viewport-narrow
  "The width below which a surface is treated as narrow.",
  :focus-offset "How far that ring sits from the control.",
  :scrollbar-thumb-hover "The thumb while the pointer is on it.",
  :touch-target
  "The smallest a control may be where there is a finger, not a mouse.",
  :radius-lg "The corner of a pane or a drawer.",
  :border-2 "A quieter line, for divisions inside one pane.",
  :measure-ceiling "The widest a line of prose may get.",
  :muted
  "A label beside something, or text that supports rather than states.",
  :ground
  "The page behind everything. Moving it moves the whole window.",
  :elevation-overlay
  "The deepest lift: a drawer or a modal over everything.",
  :icon-xl "The largest icon: an empty state, a brand mark.",
  :control-active
  "A control that is IN FORCE: today, the focused tile, the open level.",
  :brand-min-size "The smallest the brand mark may be drawn.",
  :control-face "A button's or an input's own surface.",
  :elevation-flat
  "No lift at all: a thing flush with what is behind it.",
  :opacity-hover "The strength of a hover wash.",
  :warn "It needs attention and nothing is lost yet.",
  :layer-raised "Stacked above the page, below anything sticky.",
  :brand-clear-space
  "The empty space that must surround the brand mark.",
  :sel "The background of selected text.",
  :radius-sm "The corner of a chip, a tag, a small control.",
  :opacity-dim "A thing present but not the subject.",
  :scrollbar-track "The groove a scrollbar's thumb runs in.",
  :space-4 "The padding inside an ordinary pane.",
  :elevation-floating
  "A thing floating over the page: a menu, a popover.",
  :field "The inside of a box you type in.",
  :type-body "Ordinary running text.",
  :type-small "Text beside something: a label, a caption.",
  :icon-lg "A prominent icon.",
  :motion-slow "How long a large change takes — a drawer opening.",
  :focus-width "How thick the ring around the focused control is.",
  :panel "A pane's own surface: a sidebar, a dock pane, a drawer.",
  :card "A card's surface, inside a panel.",
  :control-hover "A control while the pointer is over it.",
  :good "It worked, it is healthy, it is connected.",
  :divider
  "A line that a person must find: between two columns, or two zones. 3:1 or more against each surface.",
  :scrollbar-thumb "The part of a scrollbar you drag.",
  :hover "What any row or control turns when the pointer is over it.",
  :hl-1 "The first highlight colour a reader paints over a passage.",
  :measure-prose "How wide continuous prose reads most comfortably.",
  :crit "It failed, or it will destroy something.",
  :raised
  "A thing lifted off its panel — a card head, a control's face.",
  :accent-soft
  "A wash of the accent behind something that is in force.",
  :focus-color "The colour of that ring.",
  :accent-2
  "A lighter accent, for a second mark that must not compete.",
  :icon-md "An ordinary toolbar icon.",
  :type-h1 "The largest heading on a page.",
  :motion-ease "The curve every animation follows.",
  :stroke-hairline "The thinnest line: an ordinary divider.",
  :hl-2 "The second highlight colour.",
  :space-6 "The widest gap: between major regions.",
  :space-5 "The gap between two sections of a page.",
  :hl-4 "The fourth highlight colour.",
  :measure-floor
  "The narrowest a line of prose may get before the TYPE shrinks.",
  :space-2 "The gap between rows of a list.",
  :opacity-disabled "How faded a control is when it cannot be used.",
  :space-3 "The padding inside a small pane.",
  :font-mono
  "The typeface of code, and of anything that must line up.",
  :font-ui "The typeface of the interface.",
  :sel-text
  "The words inside a selection, so they stay readable on it.",
  :space-1
  "The tightest gap: inside a chip, between an icon and its word.",
  :scrollbar-size
  "How thick a scrollbar is — how big it has to be to hit.",
  :border "Every ordinary dividing line and control outline.",
  :body
  "The surface under the words you read, inside the reading column.",
  :accent
  "The one colour that means ACT: a primary button, a link, a focus ring.",
  :layer-overlay "The dim wash behind a drawer or a modal.",
  :hl-3 "The third highlight colour.",
  :faint "The quietest text: a count, a hint, a timestamp.",
  :elevation-raised "A small lift — a card off its panel.",
  :radius-pill "Fully round ends, for a pill or a badge.",
  :gutter
  "The right gutter beside the reading column, where marks sit.",
  :heading
  "A heading, and any text that must carry more weight than a word.",
  :layer-modal "The drawer or modal itself, above its own wash.",
  :icon-stroke "How thick an icon's line is.",
  :type-micro "The smallest text, usually a heading in capitals.",
  :text "Ordinary words."},
 :unconsumed {},
 :default :amber,
 :themes
 {:amber
  {:name "Amber",
   :builtin? true,
   :tokens
   {:control-border "#e6c96a",
    :scrollbar-thumb-hover "#6f7c86",
    :border-2 "#eed893",
    :muted "#6f7c86",
    :ground "#f7db83",
    :control-active "#cdebe0",
    :control-face "#fdf5d8",
    :warn "#c0851f",
    :sel "#6fc9ad",
    :scrollbar-track "#f9e7a6",
    :field "#fffbe9",
    :panel "#f9e7a6",
    :card "#fdf6dd",
    :control-hover "#f3e6b0",
    :good "#3f9e6f",
    :divider "#887334",
    :scrollbar-thumb "#e6c96a",
    :hover "#f3e6b0",
    :hl-1 "#ffc400",
    :crit "#cf5a5a",
    :raised "#fdf5d8",
    :accent-soft "#cdebe0",
    :accent-2 "#7fd0b8",
    :hl-2 "#5fbf3f",
    :hl-4 "#e8639b",
    :sel-text "#17403a",
    :border "#e6c96a",
    :body "#fffbe9",
    :accent "#2f9e80",
    :hl-3 "#3d9ede",
    :faint "#a08f5f",
    :gutter "#efe1a8",
    :heading "#2b3d50",
    :text "#34495d"}},
  :midnight
  {:name "Midnight",
   :builtin? true,
   :tokens
   {:control-border "#2f3644",
    :scrollbar-thumb-hover "#9aa3b2",
    :border-2 "#262c37",
    :muted "#9aa3b2",
    :ground "#15181f",
    :elevation-overlay "0 16px 40px rgb(0 0 0 / 0.65)",
    :control-active "#3a3220",
    :control-face "#242a35",
    :warn "#e0af68",
    :sel "#3a4560",
    :scrollbar-track "#1c2029",
    :elevation-floating "0 6px 16px rgb(0 0 0 / 0.55)",
    :field "#252b36",
    :panel "#1c2029",
    :card "#20252f",
    :control-hover "#2a3039",
    :good "#7bc47f",
    :divider "#6f7786",
    :scrollbar-thumb "#2f3644",
    :hover "#2a3039",
    :hl-1 "#e8c05f",
    :crit "#f7768e",
    :raised "#242a35",
    :accent-soft "#3a3220",
    :accent-2 "#f0c98f",
    :hl-2 "#8fd674",
    :hl-4 "#e392b8",
    :sel-text "#dbe6ff",
    :border "#2f3644",
    :body "#252b36",
    :accent "#e0af68",
    :hl-3 "#7aa2f7",
    :faint "#697182",
    :elevation-raised "0 1px 2px rgb(0 0 0 / 0.45)",
    :gutter "#191d25",
    :heading "#f0f3f8",
    :text "#dfe4ec"}},
  :paper
  {:name "Paper",
   :builtin? true,
   :tokens
   {:control-border "#dde1e8",
    :scrollbar-thumb-hover "#5d6773",
    :border-2 "#eaedf1",
    :muted "#5d6773",
    :ground "#f4f5f7",
    :control-active "#e6ecfb",
    :control-face "#eef0f4",
    :warn "#b5761b",
    :sel "#c9d8fb",
    :scrollbar-track "#ffffff",
    :field "#ffffff",
    :panel "#ffffff",
    :card "#ffffff",
    :control-hover "#e9ecf1",
    :good "#2f8f57",
    :divider "#7e8791",
    :scrollbar-thumb "#dde1e8",
    :hover "#e9ecf1",
    :hl-1 "#ffc400",
    :crit "#cc3b52",
    :raised "#eef0f4",
    :accent-soft "#e6ecfb",
    :accent-2 "#7d9bf0",
    :hl-2 "#5fbf3f",
    :hl-4 "#e8639b",
    :sel-text "#16336e",
    :border "#dde1e8",
    :body "#ffffff",
    :accent "#3b62d6",
    :hl-3 "#3d9ede",
    :faint "#9aa2ae",
    :gutter "#eef1f5",
    :heading "#161c25",
    :text "#26303c"}},
  :mono
  {:name "Monochrome",
   :builtin? true,
   :tokens
   {:control-border "#c8c8c8",
    :scrollbar-thumb-hover "#5a5a5a",
    :border-2 "#e0e0e0",
    :muted "#5a5a5a",
    :ground "#ffffff",
    :control-active "#ebebeb",
    :control-face "#f2f2f2",
    :warn "#3f3f3f",
    :sel "#d4d4d4",
    :scrollbar-track "#ffffff",
    :field "#ffffff",
    :panel "#ffffff",
    :card "#ffffff",
    :control-hover "#e6e6e6",
    :good "#6e6e6e",
    :divider "#888888",
    :scrollbar-thumb "#c8c8c8",
    :hover "#e6e6e6",
    :hl-1 "#000000",
    :crit "#101010",
    :raised "#f2f2f2",
    :accent-soft "#ebebeb",
    :accent-2 "#4a4a4a",
    :hl-2 "#585858",
    :hl-4 "#c4c4c4",
    :sel-text "#000000",
    :border "#c8c8c8",
    :body "#ffffff",
    :accent "#000000",
    :hl-3 "#909090",
    :faint "#8c8c8c",
    :gutter "#f2f2f2",
    :heading "#000000",
    :text "#1a1a1a"}},
  :mono-dark
  {:name "Monochrome dark",
   :builtin? true,
   :tokens
   {:control-border "#333333",
    :scrollbar-thumb-hover "#9a9a9a",
    :border-2 "#212121",
    :muted "#9a9a9a",
    :ground "#0b0b0b",
    :elevation-overlay "0 12px 32px rgb(0 0 0 / 0.65)",
    :control-active "#242424",
    :control-face "#1c1c1c",
    :warn "#c4c4c4",
    :sel "#3a3a3a",
    :scrollbar-track "#141414",
    :elevation-floating "0 4px 12px rgb(0 0 0 / 0.6)",
    :field "#1a1a1a",
    :panel "#141414",
    :card "#171717",
    :control-hover "#242424",
    :good "#9a9a9a",
    :divider "#6a6a6a",
    :scrollbar-thumb "#333333",
    :hover "#242424",
    :hl-1 "#ffffff",
    :crit "#ffffff",
    :raised "#1c1c1c",
    :accent-soft "#242424",
    :accent-2 "#c0c0c0",
    :hl-2 "#b4b4b4",
    :hl-4 "#4a4a4a",
    :sel-text "#ffffff",
    :border "#333333",
    :body "#111111",
    :accent "#ffffff",
    :hl-3 "#7c7c7c",
    :faint "#6a6a6a",
    :elevation-raised "0 1px 2px rgb(0 0 0 / 0.55)",
    :gutter "#161616",
    :heading "#ffffff",
    :text "#e8e8e8"}},
  :nord
  {:name "Nord",
   :builtin? true,
   :tokens
   {:control-border "#434c5e",
    :scrollbar-thumb-hover "#a9b3c4",
    :border-2 "#3a4150",
    :muted "#a9b3c4",
    :ground "#2e3440",
    :elevation-overlay "0 16px 40px rgb(0 0 0 / 0.60)",
    :control-active "#3b4a52",
    :control-face "#3b4252",
    :warn "#ebcb8b",
    :sel "#4c566a",
    :scrollbar-track "#343b48",
    :elevation-floating "0 6px 16px rgb(0 0 0 / 0.50)",
    :field "#3b4252",
    :panel "#343b48",
    :card "#373e4d",
    :control-hover "#414a5a",
    :good "#a3be8c",
    :divider "#8791a2",
    :scrollbar-thumb "#434c5e",
    :hover "#414a5a",
    :hl-1 "#ebcb8b",
    :crit "#bf616a",
    :raised "#3b4252",
    :accent-soft "#3b4a52",
    :accent-2 "#8fbcbb",
    :hl-2 "#a3be8c",
    :hl-4 "#b48ead",
    :sel-text "#eceff4",
    :border "#434c5e",
    :body "#3b4252",
    :accent "#88c0d0",
    :hl-3 "#81a1c1",
    :faint "#788092",
    :elevation-raised "0 1px 2px rgb(0 0 0 / 0.40)",
    :gutter "#2b313d",
    :heading "#eceff4",
    :text "#e5e9f0"}},
  :rose
  {:name "Rosé",
   :builtin? true,
   :tokens
   {:control-border "#3d3138",
    :scrollbar-thumb-hover "#b79ba6",
    :border-2 "#2f262b",
    :muted "#b79ba6",
    :ground "#201a1e",
    :elevation-overlay "0 16px 40px rgb(0 0 0 / 0.62)",
    :control-active "#43303a",
    :control-face "#332a2f",
    :warn "#e6b877",
    :sel "#4a3540",
    :scrollbar-track "#2a2226",
    :elevation-floating "0 6px 16px rgb(0 0 0 / 0.52)",
    :field "#2e2529",
    :panel "#2a2226",
    :card "#2e2529",
    :control-hover "#3a2f35",
    :good "#9ecf9a",
    :divider "#89737c",
    :scrollbar-thumb "#3d3138",
    :hover "#3a2f35",
    :hl-1 "#e6b877",
    :crit "#f2788c",
    :raised "#332a2f",
    :accent-soft "#43303a",
    :accent-2 "#efa3bd",
    :hl-2 "#9ecf9a",
    :hl-4 "#efa3bd",
    :sel-text "#ffdde8",
    :border "#3d3138",
    :body "#2e2529",
    :accent "#e0759b",
    :hl-3 "#8fb8e0",
    :faint "#7d6670",
    :elevation-raised "0 1px 2px rgb(0 0 0 / 0.42)",
    :gutter "#241c20",
    :heading "#fbeef3",
    :text "#efe0e6"}}},
 :token-vocabulary
 {:motion [:motion-fast :motion-slow :motion-ease],
  :space [:space-1 :space-2 :space-3 :space-4 :space-5 :space-6],
  :stroke [:stroke-hairline :stroke-emphasis],
  :elevation
  [:elevation-flat
   :elevation-raised
   :elevation-floating
   :elevation-overlay],
  :semantic [:good :warn :crit],
  :highlight [:hl-1 :hl-2 :hl-3 :hl-4],
  :icon-size [:icon-xs :icon-sm :icon-md :icon-lg :icon-xl],
  :surfaces
  [:ground
   :panel
   :raised
   :card
   :field
   :body
   :gutter
   :hover
   :border
   :border-2
   :divider],
  :type [:type-h1 :type-h2 :type-body :type-small :type-micro],
  :icon [:icon-stroke],
  :radius [:radius-sm :radius-md :radius-lg :radius-pill],
  :measure [:measure-floor :measure-prose :measure-ceiling],
  :font [:font-ui :font-mono],
  :brand [:brand-clear-space :brand-min-size],
  :layer
  [:layer-raised
   :layer-sticky
   :layer-overlay
   :layer-modal
   :layer-instrument],
  :opacity
  [:opacity-disabled :opacity-dim :opacity-strong :opacity-hover],
  :control
  [:control-face :control-border :control-hover :control-active],
  :focus [:focus-width :focus-offset :focus-color],
  :viewport [:viewport-narrow :touch-target :scrollbar-size],
  :scrollbar
  [:scrollbar-track :scrollbar-thumb :scrollbar-thumb-hover],
  :accent [:accent :accent-2 :accent-soft :sel :sel-text],
  :text [:text :heading :muted :faint]},
 :token-consumers
 {:accent
  ["dsl/alatus/reading-area.edn"
   "dsl/instances/conversations/conversations-ui.edn"
   "dsl/instances/crew-editor/crew-editor-ui.edn"
   "dsl/instances/kinds-acceptance/kinds-acceptance-ui.edn"
   "dsl/instances/map-of-the-system-ui.edn"
   "dsl/instances/notes/notes-ui.edn"
   "dsl/instances/reader-v2/reader-v2-ui.edn"
   "dsl/instances/reader/reader-ui.edn"
   "dsl/instances/studio-v1/studio-ui.edn"
   "dsl/platform/frame-internals-viewer.edn"
   "dsl/platform/studio-toolbar.edn"
   "resources/public/web/css/dockview.css"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/file_drop.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/island_view.cljs"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/prompt_area.cljs"
   "src/cljs/graph_ui/web/render.cljs"
   "src/cljs/graph_ui/web/ruler.cljs"
   "src/cljs/graph_ui/web/support.cljs"
   "src/cljs/graph_ui/web/tab.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"
   "src/cljs/graph_ui/web/xray.cljs"],
  :accent-2
  ["resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :accent-soft
  ["resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/prompt_area.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/xray.cljs"],
  :body
  ["dsl/alatus/reading-area.edn"
   "dsl/design/block-row.edn"
   "dsl/design/sidebar-item.edn"
   "dsl/instances/notes/notes-ui.edn"
   "resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :border
  ["dsl/instances/arch-explorer/arch-explorer-ui.edn"
   "dsl/instances/conversations/conversations-ui.edn"
   "dsl/instances/gi/gi-ui.edn"
   "dsl/instances/kinds-acceptance/kinds-acceptance-ui.edn"
   "dsl/instances/map-of-the-system-ui.edn"
   "dsl/instances/studio-v1/studio-ui.edn"
   "dsl/platform/board-detail.edn"
   "dsl/platform/board.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/file_drop.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/graph.cljs"
   "src/cljs/graph_ui/web/island_view.cljs"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/note_image.cljs"
   "src/cljs/graph_ui/web/prompt_area.cljs"
   "src/cljs/graph_ui/web/ruler.cljs"
   "src/cljs/graph_ui/web/stale.cljs"
   "src/cljs/graph_ui/web/studio.cljs"
   "src/cljs/graph_ui/web/support.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"
   "src/cljs/graph_ui/web/xray.cljs"],
  :border-2
  ["resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"],
  :brand-clear-space ["src/cljs/graph_ui/web/core.cljs"],
  :brand-min-size ["src/cljs/graph_ui/web/core.cljs"],
  :card
  ["dsl/alatus/reading-area.edn"
   "dsl/design/reference-card.edn"
   "dsl/instances/conversations/conversations-ui.edn"
   "dsl/platform/board.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/mantine-core.css"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/support.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :control-active ["resources/public/web/css/ikc-base.css"],
  :control-border
  ["resources/public/web/css/ikc-base.css"
   "resources/public/web/css/mantine-core.css"],
  :control-face ["resources/public/web/css/ikc-base.css"],
  :control-hover ["resources/public/web/css/ikc-base.css"],
  :crit
  ["dsl/platform/operability.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/stale.cljs"
   "src/cljs/graph_ui/web/support.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :divider
  ["dsl/alatus/reading-area.edn"
   "dsl/alatus/thought-body.edn"
   "dsl/alatus/thought-tree.edn"
   "dsl/instances/kinds-acceptance/kinds-acceptance-ui.edn"
   "dsl/instances/reader-v2/reader-v2-ui.edn"
   "dsl/instances/reader/reader-ui.edn"
   "dsl/platform/language.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/mantine-core.css"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/mantine_generic.cljs"],
  :elevation-flat ["src/cljs/graph_ui/web/widgets.cljs"],
  :elevation-floating
  ["resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :elevation-overlay
  ["src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :elevation-raised
  ["resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :faint
  ["resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/island_view.cljs"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/note_image.cljs"
   "src/cljs/graph_ui/web/prompt_area.cljs"
   "src/cljs/graph_ui/web/ruler.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :field
  ["dsl/design/block-row.edn"
   "dsl/instances/notes/notes-ui.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/mantine-core.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/island_view.cljs"
   "src/cljs/graph_ui/web/prompt_area.cljs"
   "src/cljs/graph_ui/web/studio.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :focus-color
  ["resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/theme.cljs"],
  :focus-offset ["resources/public/web/css/ikc-base.css"],
  :focus-width ["resources/public/web/css/ikc-base.css"],
  :font-mono
  ["resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/xray.cljs"],
  :font-ui
  ["resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/theme.cljs"],
  :good
  ["resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :ground
  ["dsl/platform/language.edn"
   "resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/render.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :gutter
  ["dsl/alatus/reading-area.edn"
   "dsl/instances/conversations/conversations-ui.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :heading
  ["dsl/platform/nightlies.edn"
   "dsl/platform/ssot.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :hl-1
  ["src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :hl-2 ["src/cljs/graph_ui/web/widgets.cljs"],
  :hl-3 ["src/cljs/graph_ui/web/widgets.cljs"],
  :hl-4
  ["src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :hover
  ["resources/public/web/css/dockview.css"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/mantine-code-highlight.css"
   "resources/public/web/css/mantine-core.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/file_drop.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"
   "src/cljs/graph_ui/web/xray.cljs"],
  :icon-lg ["src/cljs/graph_ui/web/widgets.cljs"],
  :icon-md ["src/cljs/graph_ui/web/widgets.cljs"],
  :icon-sm
  ["resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :icon-stroke ["src/cljs/graph_ui/web/widgets.cljs"],
  :icon-xl ["src/cljs/graph_ui/web/widgets.cljs"],
  :icon-xs ["src/cljs/graph_ui/web/widgets.cljs"],
  :layer-instrument ["src/cljs/graph_ui/web/xray.cljs"],
  :layer-modal
  ["resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :layer-overlay
  ["src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"
   "src/cljs/graph_ui/web/xray.cljs"],
  :layer-raised ["src/cljs/graph_ui/web/widgets.cljs"],
  :layer-sticky ["src/cljs/graph_ui/web/widgets.cljs"],
  :measure-floor ["src/cljs/graph_ui/web/theme.cljs"],
  :measure-prose ["src/cljs/graph_ui/web/theme.cljs"],
  :motion-ease ["resources/public/web/css/ikc-base.css"],
  :motion-fast ["resources/public/web/css/ikc-base.css"],
  :motion-slow ["resources/public/web/css/ikc-base.css"],
  :muted
  ["dsl/alatus/graph-view.edn"
   "dsl/alatus/reading-area.edn"
   "dsl/alatus/research-entry.edn"
   "dsl/alatus/research-guide.edn"
   "dsl/alatus/thought-body.edn"
   "dsl/alatus/thought-tree.edn"
   "dsl/instances/appliance/appliance-ui.edn"
   "dsl/instances/conversations/conversations-ui.edn"
   "dsl/instances/crew-editor/crew-editor-ui.edn"
   "dsl/instances/map-of-the-system-ui.edn"
   "dsl/instances/notes/notes-ui.edn"
   "dsl/instances/reader-v2/reader-v2-ui.edn"
   "dsl/instances/reader/reader-ui.edn"
   "dsl/instances/studio-v1/studio-ui.edn"
   "dsl/platform/attachments.edn"
   "dsl/platform/board.edn"
   "dsl/platform/frame-internals-viewer.edn"
   "dsl/platform/in-progress.edn"
   "dsl/platform/people.edn"
   "dsl/platform/studio-preview.edn"
   "dsl/platform/studio-source.edn"
   "dsl/platform/studio-toolbar.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/island_view.cljs"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/prompt_area.cljs"
   "src/cljs/graph_ui/web/ruler.cljs"
   "src/cljs/graph_ui/web/support.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"
   "src/cljs/graph_ui/web/xray.cljs"],
  :opacity-dim ["resources/public/web/css/ikc-base.css"],
  :opacity-disabled
  ["dsl/design/block-row.edn"
   "resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :opacity-hover ["resources/public/web/css/ikc-base.css"],
  :opacity-strong ["resources/public/web/css/ikc-base.css"],
  :panel
  ["resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/ruler.cljs"
   "src/cljs/graph_ui/web/support.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"
   "src/cljs/graph_ui/web/xray.cljs"],
  :radius-md
  ["src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :radius-sm ["resources/public/web/css/ikc-base.css"],
  :raised
  ["dsl/instances/crew-editor/crew-editor-ui.edn"
   "dsl/instances/notes/notes-ui.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/studio.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :scrollbar-size ["resources/public/web/css/ikc-base.css"],
  :scrollbar-thumb ["resources/public/web/css/ikc-base.css"],
  :scrollbar-thumb-hover ["resources/public/web/css/ikc-base.css"],
  :scrollbar-track ["resources/public/web/css/ikc-base.css"],
  :sel
  ["dsl/alatus/graph-view.edn"
   "dsl/alatus/reading-area.edn"
   "dsl/alatus/research-entry.edn"
   "dsl/alatus/thought-body.edn"
   "dsl/alatus/thought-tree.edn"
   "dsl/alatus/universal-sidebar.edn"
   "dsl/instances/conversations/conversations-ui.edn"
   "dsl/instances/crew-editor.edn"
   "dsl/instances/reader/reader-ui.edn"
   "dsl/instances/studio-v1/studio-ui.edn"
   "dsl/platform/board-detail.edn"
   "dsl/platform/board.edn"
   "dsl/platform/conversation-pane.edn"
   "dsl/platform/partitions.edn"
   "dsl/platform/people.edn"
   "dsl/platform/studio-source.edn"
   "dsl/platform/studio-toolbar.edn"
   "resources/public/web/css/dockview.css"
   "resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/bind.cljs"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/island_view.cljs"
   "src/cljs/graph_ui/web/render.cljs"
   "src/cljs/graph_ui/web/studio.cljs"
   "src/cljs/graph_ui/web/support.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :sel-text ["resources/public/web/css/ikc-base.css"],
  :space-1 ["src/cljs/graph_ui/web/graph.cljs"],
  :space-2 ["src/cljs/graph_ui/web/graph.cljs"],
  :space-3 ["src/cljs/graph_ui/web/graph.cljs"],
  :text
  ["dsl/alatus/book-sidebar.edn"
   "dsl/alatus/graph-view.edn"
   "dsl/alatus/reading-area.edn"
   "dsl/alatus/research-entry.edn"
   "dsl/alatus/thought-body.edn"
   "dsl/alatus/thought-tree.edn"
   "dsl/alatus/universal-sidebar.edn"
   "dsl/alatus/verse-area.edn"
   "dsl/instances/appliance/appliance-ui.edn"
   "dsl/instances/arch-explorer/arch-explorer-ui.edn"
   "dsl/instances/conversations/conversations-ui.edn"
   "dsl/instances/crew-editor/crew-editor-ui.edn"
   "dsl/instances/kinds-acceptance/kinds-acceptance-ui.edn"
   "dsl/instances/map-of-the-system-ui.edn"
   "dsl/instances/notes/notes-ui.edn"
   "dsl/instances/reader-v2/reader-v2-ui.edn"
   "dsl/instances/reader/reader-ui.edn"
   "dsl/instances/studio-v1.edn"
   "dsl/instances/studio-v1/studio-ui.edn"
   "dsl/platform/attachments.edn"
   "dsl/platform/board-detail.edn"
   "dsl/platform/board.edn"
   "dsl/platform/conversation-pane.edn"
   "dsl/platform/frame-internals-viewer.edn"
   "dsl/platform/in-progress.edn"
   "dsl/platform/people.edn"
   "dsl/platform/studio-inspector.edn"
   "dsl/platform/studio-preview.edn"
   "dsl/platform/studio-source.edn"
   "dsl/platform/studio-toolbar.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/mantine-core.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/bind.cljs"
   "src/cljs/graph_ui/web/codemirror.cljs"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/draft.cljs"
   "src/cljs/graph_ui/web/edn_indent.cljs"
   "src/cljs/graph_ui/web/file_drop.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/graph.cljs"
   "src/cljs/graph_ui/web/island_view.cljs"
   "src/cljs/graph_ui/web/locate.cljs"
   "src/cljs/graph_ui/web/mantine_generic.cljs"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/prompt_area.cljs"
   "src/cljs/graph_ui/web/render.cljs"
   "src/cljs/graph_ui/web/studio.cljs"
   "src/cljs/graph_ui/web/support.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"
   "src/cljs/graph_ui/web/xray.cljs"],
  :touch-target
  ["resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/stale.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :type-body
  ["resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/markdown.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :type-h1
  ["src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :type-h2 ["src/cljs/graph_ui/web/widgets.cljs"],
  :type-micro
  ["dsl/design/section-header.edn"
   "src/cljs/graph_ui/web/graph.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :type-small ["src/cljs/graph_ui/web/widgets.cljs"],
  :viewport-narrow
  ["dsl/alatus/reading-area.edn"
   "dsl/platform/top-bar.edn"
   "resources/public/web/css/ikc-base.css"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/render.cljs"
   "src/cljs/graph_ui/web/responsive.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"],
  :warn
  ["dsl/alatus/reading-area.edn"
   "dsl/instances/map-of-the-system-ui.edn"
   "dsl/instances/notes/notes-ui.edn"
   "dsl/instances/reader-v2/reader-v2-ui.edn"
   "dsl/instances/reader/reader-ui.edn"
   "dsl/instances/studio-v1/studio-ui.edn"
   "dsl/platform/operability.edn"
   "dsl/platform/studio-toolbar.edn"
   "resources/public/web/css/ikc-base.css"
   "resources/public/web/css/tailwind.css"
   "src/cljs/graph_ui/web/busy.cljs"
   "src/cljs/graph_ui/web/core.cljs"
   "src/cljs/graph_ui/web/generated_meta_ui.cljs"
   "src/cljs/graph_ui/web/prompt_area.cljs"
   "src/cljs/graph_ui/web/theme.cljs"
   "src/cljs/graph_ui/web/voice.cljs"
   "src/cljs/graph_ui/web/widgets.cljs"]},
 :profiles
 {:wide
  {:when :not-narrow,
   :max-tiles 6,
   :motion true,
   :stream true,
   :label "wide — the desk screen",
   :doc
   "The 48-inch panel, and a docked phone, which reports the same width and\n         a coarse pointer. DeX therefore costs no code."},
  :narrow
  {:when :narrow,
   :max-tiles 1,
   :motion true,
   :stream true,
   :label "narrow — one hand",
   :doc
   "A phone in portrait is about 360 CSS pixels wide. One tile, and the\n         :narrow slot of each node still says what that node does."},
  :still
  {:when :chosen,
   :max-tiles 1,
   :motion false,
   :stream false,
   :label "still — a slow monochrome panel",
   :doc
   "No motion, and no streamed answer: a partial repaint of an e-ink panel\n         is unreadable, so the answer arrives whole. Never derived."}},
 :base
 {:icon-xs "0.875rem",
  :opacity-strong "0.75",
  :layer-instrument "2000",
  :stroke-emphasis "2px",
  :radius-md "0.375rem",
  :motion-fast "150ms",
  :layer-sticky "20",
  :icon-sm "1rem",
  :type-h2 {:size "1.25rem", :weight 700, :line-height 1.3},
  :viewport-narrow "48rem",
  :focus-offset "2px",
  :touch-target "2.75rem",
  :radius-lg "0.5rem",
  :measure-ceiling "75ch",
  :elevation-overlay "0 12px 32px rgb(0 0 0 / 0.16)",
  :icon-xl "1.75rem",
  :brand-min-size "1rem",
  :elevation-flat "none",
  :opacity-hover "0.85",
  :layer-raised "10",
  :brand-clear-space "0.5",
  :radius-sm "0.25rem",
  :opacity-dim "0.5",
  :space-4 "1rem",
  :elevation-floating "0 4px 12px rgb(0 0 0 / 0.10)",
  :type-body {:size "0.9375rem", :weight 400, :line-height 1.55},
  :type-small {:size "0.8125rem", :weight 400, :line-height 1.5},
  :icon-lg "1.375rem",
  :motion-slow "300ms",
  :focus-width "2px",
  :measure-prose "66ch",
  :focus-color "var(--accent)",
  :icon-md "1.125rem",
  :type-h1 {:size "1.6875rem", :weight 750, :line-height 1.2},
  :motion-ease "cubic-bezier(0.4, 0, 0.2, 1)",
  :stroke-hairline "1px",
  :space-6 "2rem",
  :space-5 "1.5rem",
  :measure-floor "45ch",
  :space-2 "0.5rem",
  :opacity-disabled "0.38",
  :space-3 "0.75rem",
  :font-mono
  "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
  :font-ui
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  :space-1 "0.25rem",
  :scrollbar-size "10px",
  :layer-overlay "40",
  :elevation-raised "0 1px 2px rgb(0 0 0 / 0.06)",
  :radius-pill "9999px",
  :layer-modal "50",
  :icon-stroke "1.75",
  :type-micro
  {:size "0.6875rem",
   :weight 700,
   :line-height 1.4,
   :transform "uppercase",
   :tracking "0.05em"}},
 :gaks-refs
 {:feature ["F-graph-ui-v0-001-01-ui-quality-system"],
  :decision
  ["ADR-graph-ui-v0-009-01-rich-theming-as-data"
   "ADR-graph-ui-v0-020-01-a-widget-tree-can-name-its-surface"]}}
)
